//Global External Imports
import { useTranslation } from "react-i18next";
import React, { useEffect, useState, Fragment } from "react";

//Global Internal Imports
import apiRequest from "../../functions/api";
import { useMessage } from "../../context/message-context";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import Formular from "../Formular/Formular";
import { useZulassung } from "../../context/zulassungs-context";
import { useParams } from "react-router-dom";
import { useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";

function FormPreview() {
  const { t } = useTranslation();
  const {formKey} = useParams();
  const { zulassung } = useZulassung();
  const { mandant } = zulassung;  //Standardfelder
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorMessage, } = useMessage();
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const [formular] = useSessionStorage(LOCAL_STORAGE_KEY.formular);
  //Felderlisten
  const [felder, setFelder] = useState({});
  const [stammfelder, setStammfelder] = useState({});
  const [dbliste, setDbliste] = useState([]);

  const [formularBez, setFormularBez] = useState("");
  const [uebergaben, setUebergaben] = useState({});
  const [hper, setHper] = useState({});

  //PVX Kommunikation
  useEffect(() => {
    console.log(formular)
    init();
    // localStorage.setItem("formular", "");
    // eslint-disable-next-line
  }, [formKey]);
  const init = () => {
    setIsLoading(true);
    const payload = {
      mandant: mandant,
      program: "FORGEN",
      statement: "UEBERSICHT",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, postLaden);
  };

  function postLaden(response) {
    setIsLoading(false);
    if (response.status === 200) {
      setFelder(response.data.felder);
      setStammfelder(response.data.stammfelder);
      setHper(response.data.hper);
      //if (response.data.hperFelder) setHperFelder(response.data.hperFelder);
      if (response.data.dbliste) setDbliste(response.data.dbliste);
      if (response.data.uebergaben) {
        setUebergaben(response.data.uebergaben);
      } else {
        setUebergaben({});
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }

  //Standardfunktionen
  if (isLoading) {
    return <LoadingComponent />;
  }

  //Rückgabe
  return (
    <Fragment>
      <Formular
        bez={JSON.parse(formular)[0].name}
        formular={JSON.parse(formular)[0]?.key}
        liste={JSON.parse(formular)[0]?.inhalt ? JSON.parse(formular)[0]?.inhalt?.split(";") : []}
        felder={JSON.parse(formular)[1]}
        stammfelder={stammfelder}
        hper={hper}
        ChangeFelder={() => {}}
        felderError={[]}
        uebergaben={uebergaben}
        ChangeFiles={() => {}}
        DateiLaden={() => {}}
        dbliste={JSON.parse(formular)[0].dbliste ?? []}
        client={mandant}
        accessToken={accessToken}
        program={"FORGEN"}
      />
    </Fragment>
  );
}
export default FormPreview;
